<template>
    <div>
        <st-data-table
            :items="rows"
            :fields="fields"
            :actions="actions"
            :modelPresenter="presenter"
            @edit="onEdit"
            @delete="onDelete"
            responsive="sm"
            hover
        >
        </st-data-table>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { DecisionPurposeModel } from '@/modules/decision-purpose/decision-purpose-model';

    const { fields } = DecisionPurposeModel;

    export default {
        name: 'DecisionPurposeListTable',
        data() {
            return {
                presenter: DecisionPurposeModel.presenter,
                actions: [
                    {
                        name: 'edit',
                        icon: 'edit',
                        tooltipText: this.$t('GENERAL.ACTIONS.EDIT'),
                        customIcon: false,
                        type: 'primary'
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                        tooltipText: this.$t('GENERAL.ACTIONS.DELETE'),
                        customIcon: false,
                        type: 'primary'
                    }
                ],
            };
        },
        computed: {
            ...mapGetters({
                rows: 'decisionPurpose/list/rows',
            }),
            fields() {
                return [
                    fields.name,
                ]
            }
        },
        methods: {
            ...mapActions({
                selectRecord: 'decisionPurpose/form/select',
                deleteRecord: 'decisionPurpose/form/remove',
            }),
            async onEdit(data) {
                await this.selectRecord(data.item);
            },
            async onDelete(data) {
                await this.deleteRecord(data.item.id);
                this.$emit('update');
            },
        },
    };
</script>

<style scoped>

</style>
